export default "__VITE_ASSET__CVotKnO6__"